import { SearchOptions as AlgoliaSearchOptions } from '@algolia/client-search'

export type SearchOption = {
  index: string
  title: string
} & AlgoliaSearchOptions

export type RecommendItem = {
  index: string
  searchOptions: SearchOption[]
}

const searchRecommendations: RecommendItem[] = [
  {
    index: 'master',
    searchOptions: [
      {
        index: 'courses',
        title: 'Courses',
        hitsPerPage: 2,
      },
      {
        index: 'blogs',
        title: 'Blogs',
        hitsPerPage: 2,
      },
      {
        index: 'videos',
        title: 'Videos',
        hitsPerPage: 3,
      },
      {
        index: 'webinars',
        title: 'Webinars',
        hitsPerPage: 3,
      },
      {
        index: 'publications',
        title: 'Publications',
        hitsPerPage: 1,
      },
      {
        index: 'users',
        title: 'Users',
        hitsPerPage: 1,
      },
      {
        index: 'pages',
        title: 'Pages',
        hitsPerPage: 1,
      },
    ],
  },
  {
    index: 'courses',
    searchOptions: [
      {
        index: 'courses',
        title: 'Courses',
      },
    ],
  },
  {
    index: 'webinars',
    searchOptions: [
      {
        index: 'webinars',
        title: 'Webinars',
      },
    ],
  },
  {
    index: 'conferences',
    searchOptions: [
      {
        index: 'conferences',
        title: 'Conferences',
      },
    ],
  },
  {
    index: 'podcasts',
    searchOptions: [
      {
        index: 'podcasts',
        title: 'Podcasts',
      },
    ],
  },
  {
    index: 'videos',
    searchOptions: [
      {
        index: 'videos',
        title: 'Videos',
      },
    ],
  },
  {
    index: 'publications',
    searchOptions: [
      {
        index: 'publications',
        title: 'Publications',
      },
    ],
  },
  {
    index: 'articles',
    searchOptions: [
      {
        index: 'articles',
        title: 'Articles',
      },
    ],
  },
  {
    index: 'blogs',
    searchOptions: [
      {
        index: 'blogs',
        title: 'Blogs',
      },
    ],
  },
  {
    index: 'pages',
    searchOptions: [
      {
        index: 'pages',
        title: 'Pages',
      },
    ],
  },
]

export default searchRecommendations
